import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tag" }
const _hoisted_2 = {
  key: 0,
  class: "vue3-easy-data-table__actions"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 2,
  class: "vue3-easy-data-table__action",
  type: "button"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]

import type {FilterOption, Header, Item} from "vue3-easy-data-table"
import {useI18n} from "vue3-i18n"
import IconCalendar from "@/assets/icons/icon__calendar.svg"
import IconClipboard from "@/assets/icons/icon__clipboard.svg"
import IconParticipants from "@/assets/icons/icon__person.svg"
import IconEdit from "@/assets/icons/icon__edit.svg"
import IconMail from "@/assets/icons/icon__mail.svg"
import IconDelete from "@/assets/icons/icon__delete.svg"
import IconDownload from "@/assets/icons/icon__download.svg"
import IconTransfer from "@/assets/icons/icon__transfer.svg"
import IconView from "@/assets/icons/icon__view.svg"
import IconHeartFull from "@/assets/icons/icon__heart--full.svg"
import IconHeartEmpty from "@/assets/icons/icon__heart--empty.svg"
import IconExternal from "@/assets/icons/icon__external.svg"


export default /*#__PURE__*/_defineComponent({
  __name: 'DataTable',
  props: {
    headers: {},
    items: {},
    filterOptions: {},
    isLoading: { type: Boolean },
    searchValue: {},
    isSoloItem: { type: Boolean }
  },
  emits: ["delete", "resendUserInvite", "edit", "addFavorite", "removeFavorite"],
  setup(__props: any, { emit: __emit }) {

const {t} = useI18n()

// eslint-disable-next-line


// eslint-disable-next-line
const emit = __emit

function handleDelete(item: any) {
  emit("delete", item)
}

function handleEdit(id: string) {
  emit("edit", id)
}

function resendUserInvite(userId: string) {
  emit("resendUserInvite", userId)
}

function handleAddFavorite(id: string) {
  emit("addFavorite", id)
}

function handleRemoveFavorite(id: string) {
  emit("removeFavorite", id)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_EasyDataTable = _resolveComponent("EasyDataTable")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createBlock(_component_EasyDataTable, {
    "empty-message": _unref(t)('global.table.noData'),
    "filter-options": _ctx.filterOptions,
    headers: _ctx.headers,
    "hide-footer": _ctx.isSoloItem,
    "hide-rows-per-page": true,
    items: _ctx.items,
    loading: _ctx.isLoading,
    "rows-of-page-separator-message": _unref(t)('global.table.of'),
    "rows-per-page": _ctx.isSoloItem ? 1 : 10,
    "search-value": _ctx.searchValue,
    "table-min-height": 0,
    alternating: "",
    "buttons-pagination": "",
    "header-item-class-name": "vue3-easy-data-table__header-item",
    "theme-color": "#00ADEE"
  }, {
    "item-status": _withCtx((item) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, _toDisplayString(item.status), 1)
      ])
    ]),
    "item-actions": _withCtx((item) => [
      (item && item.actions)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
            (item.actions.view)
              ? _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: item.actions.view,
                  class: "vue3-easy-data-table__action"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IconView), { class: "icon icon--black" })
                  ]),
                  _: 2
                }, 1032, ["to"])), [
                  [_directive_tippy, _unref(t)(`global.actions.view`)]
                ])
              : _createCommentVNode("", true),
            (item.actions.download)
              ? _withDirectives((_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: item.actions.download,
                  class: "vue3-easy-data-table__action",
                  target: "_blank"
                }, [
                  _createVNode(_unref(IconDownload), { class: "icon icon--black" })
                ], 8, _hoisted_3)), [
                  [_directive_tippy, _unref(t)(`global.actions.download`)]
                ])
              : _createCommentVNode("", true),
            (item.actions.favorite && item.id)
              ? _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_4, [
                  (item.actions.favorite.isInIt)
                    ? (_openBlock(), _createBlock(_unref(IconHeartFull), {
                        key: 0,
                        class: "icon icon--black",
                        onClick: ($event: any) => (handleRemoveFavorite(item.id))
                      }, null, 8, ["onClick"]))
                    : (_openBlock(), _createBlock(_unref(IconHeartEmpty), {
                        key: 1,
                        class: "icon icon--black",
                        onClick: ($event: any) => (handleAddFavorite(item.id))
                      }, null, 8, ["onClick"]))
                ])), [
                  [_directive_tippy, item.actions.favorite.isInIt ? _unref(t)('global.actions.removeFavorite') : _unref(t)('global.actions.addFavorite')]
                ])
              : _createCommentVNode("", true),
            (item.actions.update)
              ? _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                  key: 3,
                  to: item.actions.update,
                  class: "vue3-easy-data-table__action"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IconEdit), { class: "icon icon--black" })
                  ]),
                  _: 2
                }, 1032, ["to"])), [
                  [_directive_tippy, _unref(t)(`global.actions.update`)]
                ])
              : _createCommentVNode("", true),
            (item.actions.recurrences)
              ? _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                  key: 4,
                  to: item.actions.recurrences,
                  class: "vue3-easy-data-table__action"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IconCalendar), { class: "icon icon--black" })
                  ]),
                  _: 2
                }, 1032, ["to"])), [
                  [_directive_tippy, _unref(t)(`global.actions.recurrences`)]
                ])
              : _createCommentVNode("", true),
            (item.actions.participants)
              ? _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                  key: 5,
                  to: item.actions.participants,
                  class: "vue3-easy-data-table__action"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IconParticipants), { class: "icon icon--black" })
                  ]),
                  _: 2
                }, 1032, ["to"])), [
                  [_directive_tippy, _unref(t)(`global.actions.participants`)]
                ])
              : _createCommentVNode("", true),
            (item.actions.registrations)
              ? _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                  key: 6,
                  to: item.actions.registrations,
                  class: "vue3-easy-data-table__action"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IconClipboard), { class: "icon icon--black" })
                  ]),
                  _: 2
                }, 1032, ["to"])), [
                  [_directive_tippy, _unref(t)(`global.actions.registrations`)]
                ])
              : _createCommentVNode("", true),
            (item.actions.edit && item.id)
              ? _withDirectives((_openBlock(), _createElementBlock("button", {
                  key: 7,
                  class: "vue3-easy-data-table__action",
                  type: "button",
                  onClick: ($event: any) => (handleEdit(item.id))
                }, [
                  _createVNode(_unref(IconEdit), { class: "icon icon--black" })
                ], 8, _hoisted_5)), [
                  [_directive_tippy, _unref(t)(`global.actions.update`)]
                ])
              : _createCommentVNode("", true),
            (item.actions.transfer && item.id)
              ? _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                  key: 8,
                  to: item.actions.transfer,
                  class: "vue3-easy-data-table__action"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IconTransfer), { class: "icon icon--black" })
                  ]),
                  _: 2
                }, 1032, ["to"])), [
                  [_directive_tippy, _unref(t)(`global.actions.transfer`)]
                ])
              : _createCommentVNode("", true),
            (item.actions.bill)
              ? _withDirectives((_openBlock(), _createElementBlock("a", {
                  key: 9,
                  href: item.actions.bill,
                  class: "vue3-easy-data-table__action",
                  target: "blank"
                }, [
                  _createVNode(_unref(IconExternal), { class: "icon icon--black" })
                ], 8, _hoisted_6)), [
                  [_directive_tippy, _unref(t)(`global.actions.bill`)]
                ])
              : _createCommentVNode("", true),
            (item.actions.resendUserInvite && item.userId)
              ? _withDirectives((_openBlock(), _createElementBlock("button", {
                  key: 10,
                  class: "vue3-easy-data-table__action",
                  type: "button",
                  onClick: ($event: any) => (resendUserInvite(item.userId))
                }, [
                  _createVNode(_unref(IconMail), { class: "icon icon--black" })
                ], 8, _hoisted_7)), [
                  [_directive_tippy, _unref(t)(`global.actions.resendUserInvite`)]
                ])
              : _createCommentVNode("", true),
            (item.actions.delete && item.id)
              ? _withDirectives((_openBlock(), _createElementBlock("button", {
                  key: 11,
                  class: "vue3-easy-data-table__action red-bg",
                  type: "button",
                  onClick: ($event: any) => (handleDelete(item))
                }, [
                  _createVNode(_unref(IconDelete), { class: "icon icon--black" })
                ], 8, _hoisted_8)), [
                  [_directive_tippy, _unref(t)(`global.actions.delete`)]
                ])
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["empty-message", "filter-options", "headers", "hide-footer", "items", "loading", "rows-of-page-separator-message", "rows-per-page", "search-value"]))
}
}

})